import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import eoeRatings from "../../../../src/data/articles/cube-prospective-edge-of-eternities/eoe-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  eoeRatings,
  ProspectiveIntro,
  React
};